<script lang="ts">
    import { createEventDispatcher, onMount } from 'svelte';
    import type { InteractiveTitleNumberInputDefinition } from '../../types';

    interface Props {
        field: InteractiveTitleNumberInputDefinition;
    }

    let { field }: Props = $props();

    let input = $state<HTMLInputElement | null>(null);
    let inputValue = $derived(field.value);

    onMount(() => {
        //If optional fields like `min`, `max` are not provided, input has wrongly adjusted width.
        //We have to adjust it manually to fit to value.
        changeInputSize(inputValue);
    });

    const changeInputSize = (value: number) => {
        if (!input) return;
        input.style.width = `${value.toLocaleString().length + 3}ch`;
    };
    const dispatch = createEventDispatcher();
    const onChange = (e: { currentTarget: HTMLInputElement }) => {
        const parsedValue = Number.parseInt(e.currentTarget.value, 10);
        const value =
            field.max && parsedValue > field.max
                ? field.max
                : field.min && parsedValue < field.min
                  ? field.min
                  : parsedValue;

        dispatch('change', {
            ...field,
            value,
        });
        e.currentTarget.value = value.toString();
    };
</script>

<input
    bind:this={input}
    type="number"
    min={field.min}
    max={field.max}
    value={field.value}
    onchange={onChange}
/>

<style lang="scss" scoped>
</style>
